class Cowboy extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.image = this.querySelector("img")
        this.balleSrc = this?.dataset.balleSrc
        
        this.init()
    }

    init() {
        if (!this.image) return
        this.addEventListener("click", (event) => {
            if(this.classList.contains("vente-a-background__image--shot")) {
                return
            }
            
            const impact =  document.createElement("img")

            impact.src = this.balleSrc
            impact.alt = "Balle"
            impact.className = "vente-a-background__impact"
            impact.style.left = `${event.pageX}px`
            impact.style.top = `${event.pageY}px`

            document.body.appendChild(impact)

            this.classList.add("vente-a-background__image--shot")

            setTimeout(() => {
                impact.remove()
                this.style.visibility = "hidden"
            }, 1500)  
        })
    }
}

customElements.define("cowboy-image", Cowboy);

